import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { ScrollProgress } from './components/ScrollProgress';
import { ScrollManager } from './components/ScrollManager';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
import { Readings } from './pages/Readings';
import { About } from './pages/About';
import { Journal } from './pages/Journal';
import { Article } from './pages/Article';
import { Contact } from './pages/Contact';
import { Legal } from './pages/Legal';
import { NotFound } from './pages/NotFound';
type AppProps = {
  heroBackground?: 'image' | 'dusk';
};
export function App({
  heroBackground = 'image'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3ikh829m9asyz">
      <CartProvider data-id="element-1" data-mp="3iiwfgpji5k3r">
        <ScrollManager data-id="element-2" data-mp="3ijfthv617oci" />
        <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="3ii4ro0w5cqo1">
          <Header data-id="element-4" data-mp="3mjzu58ptda3e" />
          <main id="main" className="flex-1" data-id="element-5" data-mp="3mjg93j4va5l5">
            <Routes data-id="element-6" data-mp="3rbzomln47asl">
              <Route path="/" element={<Home heroBackground={heroBackground} data-id="element-8" data-mp="3recdzjv7cnfo" />} data-id="element-7" data-mp="3rdkgu4lyihna" />
              <Route path="/shop" element={<Shop data-id="element-10" data-mp="56nfhsbnbo2" />} data-id="element-9" data-mp="4wvhonpuufq" />
              <Route path="/shop/:slug" element={<ProductDetail data-id="element-12" data-mp="2zlv7cvunj3vl" />} data-id="element-11" data-mp="7stte3h7l4p" />
              <Route path="/checkout" element={<Checkout data-id="element-14" data-mp="33mou3lwcycmw" />} data-id="element-13" data-mp="2zmo7vf30ox5a" />
              <Route path="/readings" element={<Readings data-id="element-16" data-mp="33n6xr3lcnt4u" />} data-id="element-15" data-mp="33lwyib2rgewm" />
              <Route path="/about" element={<About data-id="element-18" data-mp="38l8h7pmotugu" />} data-id="element-17" data-mp="33oi0r16z0wuw" />
              <Route path="/journal" element={<Journal data-id="element-20" data-mp="38nupjrheke04" />} data-id="element-19" data-mp="38l05w267qx7r" />
              <Route path="/journal/:slug" element={<Article data-id="element-22" data-mp="3dlnru9fl4nv4" />} data-id="element-21" data-mp="3dkl60fx4dbm2" />
              <Route path="/contact" element={<Contact data-id="element-24" data-mp="nvstj3irmlvf" />} data-id="element-23" data-mp="3dirwmsv4gdad" />
              <Route path="/legal/:page" element={<Legal data-id="element-26" data-mp="nxn6nvnsp9oy" />} data-id="element-25" data-mp="nuhicimzqbua" />
              <Route path="*" element={<NotFound data-id="element-28" data-mp="stuczpk3sn7f" />} data-id="element-27" data-mp="sudksdg1hv7q" />
            </Routes>
          </main>
          <Footer data-id="element-29" data-mp="36hxla6f4y2t" />
        </div>
        <CartDrawer data-id="element-30" data-mp="35oxut5vn8u6" />
        <ScrollProgress data-id="element-31" data-mp="356wxj89s6fx" />
      </CartProvider>
    </BrowserRouter>;
}